module.exports = __webpack_public_path__ + "TextaNarrow-Heavy-webfont.0f5be3781c8d9e115759.svg";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/TextaNarrow-Heavy-webfont.svg
// module id = ../../../../../src-admin/assets/fonts/TextaNarrow-Heavy-webfont.svg
// module chunks = styles